import PropTypes from 'prop-types';
import React from 'react';
import { FDBox, FDCallToActionButton } from '@facet-wealth/design';
import { navigateToUriInNewTab } from 'Helpers/Navigation';

const InvitationLinkButton = ({
  prompt,
  linkUrl,
}) => {
  return (
    <FDBox paddingY={2}>
      <FDCallToActionButton label={prompt} onClick={(e) => navigateToUriInNewTab(e, linkUrl, 'noopener')} />
    </FDBox>
  );
};

InvitationLinkButton.propTypes = {
  prompt: PropTypes.string.isRequired,
  linkUrl: PropTypes.string.isRequired,
};

export default InvitationLinkButton;
